<template>
  <v-dialog
    v-model="enableDialog"
    persistent
    width="580"
  >
    <v-card>
      <v-toolbar
        color="blue"
        dark
        dense
        flat
      >
        <v-toolbar-title class="white--text">
          受付通知
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text
        class="pa-4 text-center"
        style="white-space:pre-wrap; word-wrap:break-word;"
      >
        <span v-if="fromCarryinPickupShow">この内容で更新を行いますが、よろしいですか？<br></span>
        <span v-else>
          <span v-if="fromCollectionRequest">この内容で排出事業者へ通知されますが、よろしいですか？<br></span>
          <span v-else>
            <span v-if="emissionApproval">この内容で排出者申請を行いますが、よろしいですか？<br></span>
            <span v-else>この内容で受注登録を行いますが、よろしいですか？<br></span>
          </span>
        </span>
        <span v-if="repeatSetting != 'unuse_repeat'">繰り返し設定を実施します。登録には時間がかかる為、一覧への反映が遅れる可能性があります。ブラウザーを更新して確認下さい</span>
        <span v-if="includingPaper">紙マニフェストのため排出事業者へ承認依頼メールが送信されません</span>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn
          color="grey"
          text
          @click="closeButtonClickEvent"
        >
          Cancel
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="registerButtonClickEvent1"
        >
          OK
        </v-btn>
        <v-btn
          v-if="isBilling && enableToDealButton"
          color="primary"
          text
          @click="registerButtonClickEvent2"
        >
          OKして売上入力へ進む
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {mapState} from 'vuex'

export default {
  name: 'RegistrationProvisionalDialog',
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    enableToDealButton: {
      type: Boolean,
      default: () => true,
    },
    fromCollectionRequest: {
      type: Boolean,
      default: () => true,
    },
    fromCarryinPickupShow: {
      type: Boolean,
      default: () => false,
    },
    emissionApproval: {
      type: Boolean,
      default: () => false,
    },
    repeatSetting: {
      type: String,
      default: () => null,
    },
    includingPaper: {
      type: Boolean,
      default: () => false,
    },
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isBilling: 'use_billing',
    }),
  },
  methods: {
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    registerButtonClickEvent1 () {
      let afterTransaction = false
      this.$emit('registerCallback', afterTransaction)
    },
    registerButtonClickEvent2 () {
      let afterTransaction = true
      this.$emit('registerCallback', afterTransaction)
    },
  }
}

</script>

<style scoped lang="scss">
</style>
